import WelcomeScreen from './Welcome';
import ManageAdmins from './ManageAdmins';
import ManageDealers from './ManageDealers';
import SubscriptionScreens from './Subscription';
import ManageEmployees from './ManageEmployees';
import SubscriptionHistory from './SubscriptionHistory';
import AVGenerationHistory from './AVGenerationHistory';
import AVRules from './AVRules';
import MasterData from './MasterData';
import UCIReportScreens from './UCIReport';
import OpenRepairOrderScreens from './OpenRepairOrder';
import ViewContentScreens from './ViewContent';
import AllSettingScreens from './Settings';
import PasswordScreens from './Password';
import AppraisalResultScreens from './AppraisalResult/IE';
import ManageNotification from './ManageNotification';


export default {
  ...WelcomeScreen,
  ...ManageAdmins,
  ...ManageDealers,
  ...SubscriptionScreens,
  ...ManageEmployees,
  ...SubscriptionHistory,
  ...AVGenerationHistory,
  ...AVRules,
  ...MasterData,
  ...UCIReportScreens,
  ...OpenRepairOrderScreens,
  ...ViewContentScreens,
  ...AllSettingScreens,
  ...PasswordScreens,
  ...AppraisalResultScreens,
  ...ManageNotification
};
